import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
// unused imports removed
import Header from "../../../components/Header";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { setupManagementUrl } from "../../../config";
const base_url = setupManagementUrl.uri;
//const base_url = "https://localhost:7210/graphql/"
/**
 * IntervalForm
 *
 * This component is used to create or edit an interval. It renders a form with
 * an input for the interval and a submit button. The form is wrapped in a
 * Formik component which handles the form state and the validation of the
 * form fields.
 *
 * @param {Object} props - The props of the component.
 * @param {boolean} props.isEditing - Whether the form is being used to edit an
 * existing interval or to create a new one.
 * @param {Object} props.data - The data of the interval to be edited. This
 * prop is only used if `isEditing` is true.
 * @param {Function} props.onClose - A function that is called when the form is
 * submitted and the modal is closed.
 * @param {Function} props.refetchData - A function that is called when the form is
 * submitted and the data of the interval is updated.
 */

const CustomerTypesForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    typeName: props.data ? props.data.typeName : "",
    discountPercentage: props.data ? props.data.discountPercentage : "",
  };

  const validationSchema = yup.object().shape({
    typeName: yup.string().required("TypeName is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { typeName, discountPercentage } = values;
      const DiscountPercentage = parseFloat(discountPercentage || 0);
      const mutationData = {
        typeName,
        discountPercentage: DiscountPercentage,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
        mutationData.updatedBy = userId;
        mutationData.createdBy = props.data.createdBy;
      } else {
        mutationData.createdBy = userId;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCustomerTypes" : "createCustomerTypes",
        mutationData,
        "customerTypes",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `CustomerType ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px" bgcolor="background.paper" p={3}>
      <Header
        title={props.isEditing ? "Edit CustomerType" : "Create CustomerType"}
        subtitle={
          props.isEditing
            ? "Edit an existing CustomerType"
            : "Create a new CustomerType"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="CustomerType Name *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.typeName}
                name="typeName"
                error={touched.typeName && !!errors.typeName}
                helperText={touched.typeName && errors.typeName}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Discount Percentage *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.discountPercentage}
                name="discountPercentage"
                error={touched.discountPercentage && !!errors.discountPercentage}
                helperText={touched.discountPercentage && errors.discountPercentage}
              />

              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CustomerTypesForm;
